export const HomefaqData = [
  {
    question: "Does Laxmi import all its products from india?",
    answer:
      "Majority yes. But we source globally/internationally to ensure that we offer the best quality products to our consumers.",
  },
  {
    question:
      "How does Laxmi maintain the same level of quality across all its products?",
    answer:
      "HOS, Laxmi has a robust QA system in place which ensures material and process specification pre and post-production, rigorous vendor audits, routine visits to scheduled virtual e-meets, routine sampling, ensuring validation of products through COA and in-house testing, third party audits, external lab testing, regular monitoring and training, There is a defined Food safety Program with the accountability of stakeholders, very aggressive and transparent supply chain system, defined organisation goals, strong vendor management process and product sampling. All these help Laxmi in having the same level of quality across all its products.",
  },
  {
    question: "Are Laxmi products FDA approved?",
    answer: "Yes, all our products are in compliance with USFDA.",
  },
  {
    question: "In how many locations is laxmi present in the United States?",
    answer:
      'We are present nationally except a few places. Click <a href="https://laxmihos.com/store-locator">here</a> to go to our store locator.',
  },
  {
    question: "Does Laxmi deliver directly to consumer?",
    answer:
      "No, but for selected items, we deliver through e-commerce partners like Amazon.",
  },
  {
    question: "How does one purchase Laxmi products in bulk?",
    answer:
      "To purchase Laxmi Products in bulk, contact us at <a href='mailto:customerservice@laxmihos.com'>customerservice@laxmihos.com</a>",
  },
];
